import React, { useEffect } from 'react'

export default function About(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - About Me";
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/me_600.png'}
                    srcSet={`/images/me_1200.png 4000w`}
                    alt="Vabis"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1 style={{fontSize: 20, textAlign: 'justify'}}>Hi, I am Vabis.</h1>
                    </header>
                    <p style={{textAlign: 'justify'}}>I've been passionate about literature since childhood. My love for reading started when my dad would bait me to wake-up early for school, just so he could read me a story at breakfast time. The illustrations would captivate my imagination and I grew more fascinated with the world of fiction.</p>
                    <p style={{textAlign: 'justify'}}>By the age of ten, the world of fiction had captivated me so much, that I'd eagerly anticipate literature periods at school. At lunchtime and in my free-time, I'd voraciously read stories by Roald Dahl (I'm still a big fan of his works). I was a frequent visitor of the bookshop next door and by age twenty, I owned over one thousand fiction books- a testament to my love of reading.</p>
                    <p style={{textAlign: 'justify'}}>Soon enough in 2016, I went to pursue a MA in Literature (specialising in Childrens Literature). It felt like the next natural step to pursue my love for fiction. I was a topper in my class and graduated with distinction in 2019. I then went on to pursue an MA in Children's Literature (2020-2021) from Roehampton University, London, UK. I passed with Merits in 2021. </p>
                    <p style={{textAlign: 'justify'}}>Soon after graduating, I opened this company. I will treat your piece of work with confidentiality, commitment and passion. </p>
                </div>
            </div>
        </div>
    )
}
